import { apiFetch } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerPushSubscription() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) return;

  const token = localStorage.getItem("solvit_auth_token");
  if (!token) return;

  let permission = Notification.permission;
  if (permission === "default") {
    permission = await Notification.requestPermission();
  }
  if (permission !== "granted") return;

  const vapid = await apiFetch("/api/push/vapid-public-key").catch(() => null);
  if (!vapid?.enabled || !vapid?.publicKey) return;

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapid.publicKey),
    });
  }

  await apiFetch("/api/push/subscriptions", {
    method: "POST",
    body: {
      subscription: subscription.toJSON(),
      userAgent: navigator.userAgent,
    },
  });
}

export async function unregisterPushSubscription() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

  const token = localStorage.getItem("solvit_auth_token");
  if (!token) return;

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;

  await apiFetch("/api/push/subscriptions", {
    method: "DELETE",
    body: { endpoint: subscription.endpoint },
  }).catch(() => null);

  await subscription.unsubscribe().catch(() => null);
}
